import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
// import PropTypes from 'prop-types';
import _ from 'lodash';
import { reducePaths, storePaths } from '@utils/Tools';
import { changeLanguage, changeMode } from '@actions';

import { Container, Grid, Accordion, AccordionDetails, AccordionSummary, Link, useMediaQuery, Slide } from '@mui/material';
import { useTheme, styled, makeStyles } from '@mui/styles';

//ICONS
import { FiCheck, FiX } from "react-icons/fi";
import { BsInstagram } from "react-icons/bs";
import { FaFacebookSquare } from "react-icons/fa";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function Footer() {
    const { t, i18n } = useTranslation();
    let location = useLocation();
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const theme = useTheme();
    const styles = useStyles();
    
    const [certDialog, setCertDialog] = useState(false);
    const [certDialogImg, setCertDialogImg] = useState('');
    
    const mobileView = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    const goBack = () => {
        if (_.size(location?.state?.from) > 0) {
            let path = _.size(location?.state?.from) > 0 ? _.last(location?.state?.from) : '/';
            let pathListing = reducePaths(location);
            let urlLink = path?.pathname;
            if (path?.search !== '') {
                urlLink = urlLink + path?.search;
            }
            navigate(urlLink, { state: { from: pathListing } });
        } else {
            navigate('/');
        }
    }
    //Copyright Timezone
    const malaysiaYear = new Date().toLocaleString('en-MY', {
        timeZone: 'Asia/Kuala_Lumpur',
        year: 'numeric'
    });

    //Accordion
    const [expanded, setExpanded] = React.useState(false);
    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleChangeLanguage = (lang) => {
        i18n.changeLanguage(lang);
        dispatch(changeLanguage(lang));
    }
    
    const quickLinks = [
        { path: '#about', title: t('title.about') },
        { path: '#advantage', title: t('title.advantage') },
        { path: '#works', title: t('title.howItWork') },
        { path: '#partners', title: t('title.partners') },
        { path: '#contact', title: t('title.contact') }
    ];
    const policies = [
        // { path: '/term-of-use', title: t('title.termOfUse') },
        { path: '/po-programe-rnr', title: t('title.rulesRegulations') },
        // { path: '/shipping-and-fulfillment', title: t('title.shippingPolicy') },
        // { path: '/exchange-policy', title: t('title.returnExchangePolicy') }
    ];
    const languageOptions = [
        { code: 'en', label: 'English (US)' },
        // { code: 'ru', label: 'Русский' },
        { code: 'cn', label: '简体中文' }
    ];

    const summary = (
        <>
            <div className='lh-12'>
                <p className='fs-title-b p-b-5 txt-upper'>{t('title.company')}</p>
                <p>{t('footer.desc')}</p>
            </div>
            {/* <div className='footer-icon-container'>
                <FaFacebookSquare />
                <BsInstagram />
            </div> */}
        </>
    )

    return (
        <div 
        style={{
             background: "linear-gradient(180deg, #2B1B3F 0%, #462E5E 100%)",
             color: "#FFFFFF",
         }}>
            <Container className='p-tb-50'>
                {mobileView ?
                    <>
                        {summary}
                        <div>
                            <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1bh-content"
                                    id="panel1bh-header"
                                >
                                    <p className='txt-upper w-full'>{t('general.quickLinks')}</p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div className='w-full flex-col-l gap-15'>
                                        {quickLinks.map((quicklinks) => (
                                            <Link to={quicklinks.path} target='_top' underline='none' component={RouterLink} style={{padding:0}}>
                                                <div className='clwhite'>
                                                    <p>{quicklinks.title} </p>
                                                </div>
                                            </Link>
                                        ))}
                                    </div>
                                    {/* <Link
                                        className='pointer'
                                        key={quicklinks.code}
                                        target='_top'
                                        onClick={() => navigate(quicklinks.path)}
                                    >
                                        <p>{quicklinks.title}</p>
                                    </Link> */}
                                </AccordionDetails>
                            </Accordion>
                            <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel2bh-content"
                                    id="panel2bh-header"
                                >
                                    <p className='txt-upper w-full'>{t('general.policies')}</p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div className='w-full flex-col-l gap-15 pointer'>
                                        {policies.map((policies) => (
                                            <div
                                                className='pointer'
                                                key={policies.path}
                                                onClick={() => navigate(policies.path)}
                                            >
                                                <p>{policies.title}</p>
                                            </div>
                                        ))}
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel3bh-content"
                                    id="panel3bh-header"
                                >
                                    <p className='txt-upper w-full'>{t('general.language')}</p>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div className='flex-col-l w-full gap-10 pointer'>
                                        {languageOptions.map((lang) => (
                                            <div
                                                key={lang.code}
                                                className={`flex-m gap-15 w-full pointer ${i18n.resolvedLanguage === lang.code ? 'inter-bold' : ''}`}
                                                onClick={() => handleChangeLanguage(lang.code)}
                                            >
                                                <p>{lang.label}</p>
                                                {i18n.resolvedLanguage === lang.code && <FiCheck className='fs-21' />}
                                            </div>
                                        ))}
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        </div>
                    </>
                    :
                    <Grid container>
                        <Grid item xs={12} sm={4}>
                            <div style={{width:'80%'}}>
                                {summary}
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={8}>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={4}>
                                    <div className='flex-col-l w-full gap-10'>
                                        <p className='txt-upper op-08 p-b-10'>{t('general.quickLinks')}</p>
                                        {/* {quickLinks.map((quicklinks, index) => (
                                            <div
                                                className='pointer'
                                                key={index}
                                                onClick={() => navigate(quicklinks.path)}
                                            >
                                                <p>{quicklinks.title}</p>
                                            </div>
                                        ))} */}
                                        {quickLinks.map((quicklinks) => (
                                            <Link to={quicklinks.path} target='_top' underline='none' component={RouterLink} style={{padding:0}}>
                                                <div className='clwhite'>
                                                    <p>{quicklinks.title} </p>
                                                </div>
                                            </Link>
                                        ))}
                                    </div>
                                </Grid>

                                <Grid item xs={12} sm={5}>
                                    <div className='flex-col-l w-full gap-10'>
                                        <p className='txt-upper op-08 p-b-10'>{t('general.policies')}</p>
                                        {policies.map((policies, index) => (
                                            <div
                                                className='pointer'
                                                key={index}
                                                onClick={() => navigate(policies.path)}
                                            >
                                                <p>{policies.title}</p>
                                            </div>
                                        ))}
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <div className='flex-col-l w-full gap-10'>
                                        <p className='txt-upper op-08 p-b-10'>{t('general.language')}</p>
                                        {languageOptions.map((lang) => (
                                            <div
                                                key={lang.code}
                                                className={`flex-m gap-15 pointer w-full ${i18n.resolvedLanguage === lang.code ? 'inter-bold' : ''}`}
                                                onClick={() => handleChangeLanguage(lang.code)}
                                            >
                                                <p>{lang.label}</p>
                                                {i18n.resolvedLanguage === lang.code && <FiCheck className='fs-21' />}
                                            </div>
                                        ))}
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                }
                <p className='txt-center p-t-40'>2019 - {malaysiaYear}  Copyright © {t('title.company')}</p>
            </Container>
        </div>
    );
}



const useStyles = makeStyles((theme) => ({

}));